import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import FileInput, { FileDetails } from "@amzn/meridian/file-input";
import { batchExtraction, setUploadFile, BATCH_PROCESS_URL } from "src/store/batchExtractionSlice";
import Button from "@amzn/meridian/button";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { createToast } from "src/store/toastsSlice";
import { TOAST_TIMEOUT } from "src/config/Toast";
import Column from "@amzn/meridian/column";
import Toggle from "@amzn/meridian/toggle";
import React from "react";
import SampleCSVTemplateLink from "src/components/shared/csvTemplate/sampleCSVTemplateLink";
import { SOURCE_ID, SOURCE_TEXT } from "src/constants";
import ModelSelect from "src/components/shared/modelSelect/modelSelect";
import { resetBatchExtractionApi } from "src/store/batchExtractionSlice";
import { removeApiError } from "src/store/errorBoundarySlice";
import { getFileInfoWithProperLength } from "src/utils/fileUtil";

const UploadSection = () => {
  const dispatch = useAppDispatch();
  const { uploadFile, batchExtractionLoading, generateLLMClarification } = useAppSelector(
    (state) => state.batchExtractionSlice,
  );
  const { selectedModelId } = useAppSelector((state) => state.modelSlice);

  const { apiErrors } = useAppSelector((state) => state.errorBoundary);

  const getErrorMessage = (uploadFile: File | undefined, selectedModelId: string) => {
    if (!uploadFile && selectedModelId === "") {
      return "Please upload csv document and select extraction model";
    } else if (!uploadFile) {
      return "Please upload csv document";
    } else if (selectedModelId === "") {
      return "Please select extraction model";
    }
  };

  const handleSubmitBatchProcessJob = () => {
    if (uploadFile && selectedModelId !== "") {
      dispatch(
        batchExtraction({
          file: uploadFile,
          modelId: selectedModelId,
          generateLLMClarification: generateLLMClarification,
        }),
      );
    } else {
      dispatch(
        createToast({
          type: "error",
          message: getErrorMessage(uploadFile, selectedModelId),
          timeout: TOAST_TIMEOUT,
        }),
      );
    }
  };

  return (
    <>
      <Row alignmentHorizontal={"start"}>
        <Text fontFamily="bookerly" type={"d50"}>
          Upload file to extract
        </Text>
      </Row>
      <Row alignmentHorizontal={"justify"} widths={"100%"}>
        <FileInput
          type="single"
          onFileAttached={(acceptedFiles) => {
            dispatch(removeApiError(BATCH_PROCESS_URL));
            dispatch(resetBatchExtractionApi());
            dispatch(setUploadFile(acceptedFiles[0]));
          }}
          uploadButtonType={"secondary"}
          accept=".csv"
          showDropZone={true}
          dropZoneDirection={"row"}
        />
      </Row>
      <Row widths="100%">
        {uploadFile && (
          <FileDetails
            file={getFileInfoWithProperLength(uploadFile)}
            onClickRemoveFile={() => dispatch(setUploadFile(undefined))}
            cancelUploadButtonLabel={`Cancel, ${uploadFile.name}`}
            removeFileButtonLabel={`Delete, ${uploadFile.name}`}
            uploadComplete={uploadFile !== undefined}
            error={batchExtractionLoading === "rejected"}
            errorMessage={apiErrors[BATCH_PROCESS_URL]}
          />
        )}
      </Row>
      <Row alignmentHorizontal={"start"}>
        <ModelSelect></ModelSelect>
      </Row>
      {selectedModelId !== "" && (
        <SampleCSVTemplateLink columnNames={[SOURCE_ID, SOURCE_TEXT]}></SampleCSVTemplateLink>
      )}
      <Row alignmentHorizontal={"start"}>
        <Button
          onClick={() => dispatch(handleSubmitBatchProcessJob)}
          disabled={batchExtractionLoading === "pending"}
        >
          Submit batch extraction job
        </Button>
      </Row>
    </>
  );
};

export default UploadSection;
